/****   http.js   ****/
import request from './request'

const http = {
    get(url, params, requestConfig = {}) {
        const config = {
            ...requestConfig,
            method: 'get',
            url: url
        }
        if (params) config.params = params
        return request(config)
    },
    post(url, params, requestConfig = {}) {
        const config = {
            ...requestConfig,
            method: 'post',
            url: url
        }
        if (params) config.data = params
        return request(config)
    },
    put(url, params, requestConfig = {}) {
        const config = {
            ...requestConfig,
            method: 'put',
            url: url,
        }
        if (params) config.data = params
        return request(config)
    },
    delete(url, params, requestConfig = {}) {
        const config = {
            ...requestConfig,
            method: 'delete',
            url: url
        }
        if (params) config.params = params
        return request(config)
    }
}

export default http
